export default "__VITE_ASSET__DHxUn8al__"